export default {
    AssetRegister: 'assetRegister',
    CheckIns: 'checkIns',
    Compliance: 'compliance',
    Goals: 'goals',
    OrgChart: 'orgChart',
    PositionDescriptions: 'positionDescriptions',
    PerformanceReviews: 'performanceReviews'
}